var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header has-shadow"},[_c('div',{staticClass:"container"},[_c('MainNavigation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }